// ===== Services -> ikon (URL + címke) mapping (globális) =====
var PM_ICON_MAP = [
  { kind:'auto',    match:['autó','auto','autok','car','cars','gépkocsi','gepkocsi'],
    url:'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/auto.png?v=1762264104', title:'Autó' },
  { kind:'cipo',    match:['cipő','cipo','shoes','shoe'],
    url:'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/cipo.png?v=1762264103', title:'Bőrtárgyak' },
  { kind:'kabat',   match:['kabát','kabat','jacket','coat'],
    url:'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/kabat_1_1.png?v=1762263942', title:'Kabát' },
  { kind:'hajo',    match:['hajó','hajo','boat','yacht'],
    url:'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/hajo.png?v=1762264110', title:'Hajó' },
  { kind:'kanape',  match:['kanapé','kanape','sofa','couch','furniture','bútor','butor'],
    url:'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/kanape.png?v=1762264113', title:'Kanapé / Bútor' },
  { kind:'kormany', match:['kormány','kormany','steering','steering wheel'],
    url:'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/kormany.png?v=1762264116', title:'Kormány' }
];

function pmNormalize(s){
  try { return String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
  catch(_){ return String(s||'').toLowerCase(); }
}

function pmFindIcon(serviceName){
  var t = pmNormalize(serviceName);
  for (var i=0;i<PM_ICON_MAP.length;i++){
    var row = PM_ICON_MAP[i];
    for (var j=0;j<row.match.length;j++){
      var m = pmNormalize(row.match[j]);
      if (t === m || t.indexOf(m) !== -1) return row;
    }
  }
  return null;
}
// --- Partner tracking helper (GA4 / gtag + dataLayer fallback) ---
function pmPartnerKey(p){
  try{
    var base = (p.city || '') + '-' + (p.name || '');
    return pmNormalize(base).replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  }catch(_){
    return '';
  }
}

function pmTrack(eventName, p, extra){
  try{
    var params = extra || {};
    params.partner_key  = pmPartnerKey(p) || '';
    params.partner_name = p && p.name  ? p.name  : '';
    params.partner_city = p && p.city  ? p.city  : '';

    // 1) Elsődleges: gtag (Shopify Google & YouTube app / Google tag)
    if (typeof window.gtag === 'function') {
      // Ha valaha akarsz konkrét GT / GA4 ID-t küldeni:
      // ha beállítasz egy window.PM_SEND_TO = 'GT-XXXXXX' vagy 'G-XXXXXX' változót,
      // akkor arra fog menni explicit.
      if (window.PM_SEND_TO) {
        window.gtag('event', eventName, Object.assign({}, params, {
          send_to: window.PM_SEND_TO
        }));
      } else {
        window.gtag('event', eventName, params);
      }
    }

    // 2) Másodlagos: ha később GTM-re váltasz, legyen dataLayer event is
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({}, params, {
        event: eventName
      }));
    }

    // 3) Debugoláshoz (böngésző konzolban látod, mi megy ki)
    if (window.PM_DEBUG) {
      console.log('[pmTrack]', eventName, params);
    }
  }catch(e){
    if (console && console.warn) console.warn('pmTrack hiba:', e);
  }
}


function pmIconHtml(iconRow){
  var title = iconRow.title || '';
  return '' +
    '<div class="pc-skill" data-kind="'+iconRow.kind+'" data-title="'+title+'" title="'+title+'">' +
      '<img class="pc-skill-img" src="'+iconRow.url+'" alt="'+title+'" loading="eager" decoding="async">' +
    '</div>';
}
// --- global safety stubs (először mindig legyenek elérhetők) ---
window.isMobile = window.isMobile || function(){
  try { return window.matchMedia('(max-width: 991px)').matches; }
  catch(_) { return false; }
};


/* Partner Map – minimal guaranteed build (partners.json only) + style selector */
(function(){
  var cfg = window.__PARTNER_MAP__ || {};
  var state = {
    map: null,
    data: [],
    markersSourceId: 'partners',
    clustersLayerId: 'clusters',
    clusterCountLayerId: 'cluster-count',
    unclusteredLayerId: 'unclustered',
    popup: null
  };

  function $(s){ return document.querySelector(s); }

  

// mobilos javaslat-zárás/clear segédfüggvény
function clearSearchUI(){
  try{
    var input   = document.getElementById('partnerSearch');
    var results = document.getElementById('searchResults');

    if (results){ results.innerHTML = ''; results.classList.remove('open'); }
    if (input){
      input.value = '';
      input.blur();
      // hogy a külső logika (pl. filter) azonnal reagáljon
      input.dispatchEvent(new Event('input', { bubbles:true }));
    }
  }catch(_){}
}

  function parseBounds(boundsStr){
    try{
      var parts = String(boundsStr||'').split('|');
      var sw = parts[0].split(','), ne = parts[1].split(',');
      var s = parseFloat(sw[0]), w = parseFloat(sw[1]);
      var n = parseFloat(ne[0]), e = parseFloat(ne[1]);
      if (isFinite(s)&&isFinite(w)&&isFinite(n)&&isFinite(e)) return [[w,s],[e,n]];
    }catch(_){}
    return [[16.11,45.74],[22.90,48.58]]; // HU fallback
  }

  function escapeHtml(str){
    var map = {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"};
    return String(str||'').replace(/[&<>"']/g, function(s){ return map[s]; });
    window.escapeHtml = window.escapeHtml || escapeHtml;
  }

  function normalizeRecord(r){
  if (!r) return null;
  var lat = parseFloat(r.lat != null ? r.lat : r.latitude);
  var lng = parseFloat(r.lng != null ? r.lng : r.longitude);
  if (!isFinite(lat) || !isFinite(lng)) return null;

  var services = [];
  if (r.services) {
    services = Array.isArray(r.services)
      ? r.services
      : String(r.services).split(',').map(function(x){ return x.trim(); }).filter(Boolean);
  }

  var out = {
    name: r.name || r.title || 'Ismeretlen partner',
    lat: lat,
    lng: lng,
    address: r.address || '',
    city: r.city || '',
    postal_code: r.postal_code || r.zip || '',
    phone: r.phone || '',
    email: r.email || '',
    services: services,
    google_maps_url: r.google_maps_url || r.google || '',
    website: r.website || '',
    logo: r.logo || '',
    notes: r.notes || ''
  };

  if (r.info_icon_url || r.infoIcon) out.info_icon_url = r.info_icon_url || r.infoIcon;
  if (r.info_title    || r.infoTitle) out.info_title    = r.info_title    || r.infoTitle;
  if (r.info_text     || r.infoText)  out.info_text     = r.info_text     || r.infoText;

  return out;
}

function featuresFrom(arr){
  return {
    type: 'FeatureCollection',
    features: arr.map(function(p){
      return {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [p.lng, p.lat] },
        properties: { json: JSON.stringify(p) }
      };
    })
  };
}

function renderCard(p){
  var locLine  = [p.postal_code, p.city].filter(Boolean).join(' ') || p.city || '';
  var fullAddr = [p.address, locLine].filter(Boolean).join(', ');
var emailBadge = '';
if (p.email) {
  emailBadge =
    '<div class="pc-email">' +
      '<img class="pc-email-ico" src="https://cdn.shopify.com/s/files/1/0679/3333/9954/files/gmaillogo.png?v=1762040165" alt="" width="15" height="15">' +
      '<a href="mailto:'+escapeHtml(p.email)+'" class="pc-email-link">'+escapeHtml(p.email)+'</a>' +
    '</div>';
}
  var svc = Array.isArray(p.services) ? p.services : [];
  function asText(s){
    // szolgáltatás → ikon URL + canonical kind
var ICONS = [
  { k: 'auto',   names: ['autó','auto','autok','car','cars','gépkocsi','gepkocsi'],  url: 'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/auto.png?v=1762044073',      title: 'Autó' },
  { k: 'cipo',   names: ['cipő','cipo','shoes','shoe'],                               url: 'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/cipo.png?v=1762044070',      title: 'Bőrtárgyak' },
  { k: 'kabat',  names: ['kabát','kabat','jacket','coat'],                             url: 'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/kabat.png?v=1762044065',     title: 'Kabát' },
  { k: 'hajo',   names: ['hajó','hajo','boat','yacht'],                                url: 'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/hajo.png?v=1762044076',      title: 'Hajó' },
  { k: 'kanape', names: ['kanapé','kanape','sofa','kanapee','couch','furniture','bútor','butor'], url: 'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/kanape.png?v=1762044081', title: 'Kanapé / Bútor' },
  { k: 'kormany',names: ['kormány','kormany','steering','steering wheel'],            url: 'https://cdn.shopify.com/s/files/1/0679/3333/9954/files/kormany.png?v=1762044083',  title: 'Kormány' }
];

function findIconByServiceName(s){
  var t = asText(s);
  for (var i=0;i<ICONS.length;i++){
    var row = ICONS[i];
    for (var j=0;j<row.names.length;j++){
      if (asText(row.names[j]) === t) return row; // pontos név egyezés
    }
    // laza egyezés (pl. "autó polírozás" tartalmazza az "autó"-t)
    for (var j2=0;j2<row.names.length;j2++){
      if (t.indexOf(asText(row.names[j2])) !== -1) return row;
    }
  }
  return null;
}

    try { return String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
    catch(_){ return String(s||'').toLowerCase(); }
  }
  function iconHtml(kind, title){
    var data = ' data-kind="'+kind+'" data-title="'+(title||'')+'"';
    if (kind === 'furniture') {
      return '<div class="pc-skill"'+data+' title="'+title+'"><svg viewBox="0 0 56 56" aria-hidden="true"><path d="M4 11h16a2 2 0 0 1 2 2v3h-3v3h-2v-3H7v3H5v-3H2v-3a2 2 0 0 1 2-2zm1-5h14a2 2 0 0 1 2 2v3H3V8a2 2 0 0 1 2-2z" fill="currentColor"/></svg></div>';
    }
    if (kind === 'car') {
      return '<div class="pc-skill"'+data+' title="'+title+'"><svg viewBox="0 0 56 56" aria-hidden="true"><path d="M3 13l2-5a3 3 0 0 1 2.8-2h8.4A3 3 0 0 1 19 8l2 5v5h-2a2 2 0 1 1-4 0H9a2 2 0 1 1-4 0H3v-5zm3.5 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" fill="currentColor"/></svg></div>';
    }
    return '';
  }

// --- ikonok a services alapján (max 6) ---
var rawIcons = [];
for (var i=0; i<svc.length && rawIcons.length<6; i++){
  var row = pmFindIcon(svc[i]);
  if (row) rawIcons.push(pmIconHtml(row));
}

var skillsHtml = '';
if (rawIcons.length){
  // első sor: 2. ikon bal, 1. ikon közép, 3. ikon jobb
  var ghost = '<div class="pc-skill ghost" aria-hidden="true"></div>';
  var first  = rawIcons[0] || ghost;
  var second = rawIcons[1] || ghost;
  var third  = rawIcons[2] || ghost;

  var row1 = ''
    + second.replace('<div class="pc-skill"', '<div class="pc-skill first-row" style="grid-column:1"')
    + first .replace('<div class="pc-skill"', '<div class="pc-skill first-row" style="grid-column:2"')
    + third .replace('<div class="pc-skill"', '<div class="pc-skill first-row" style="grid-column:3"');

  var rest = rawIcons.slice(3).join('');

  skillsHtml = '<div class="pc-skills" data-count="'+rawIcons.length+'">' + row1 + rest + '</div>';
}



 var avatar = p.logo
  ? '<img class="pc-avatar" src="'+escapeHtml(p.logo)+'" alt="'+escapeHtml(p.name)+'" width="300" height="300" loading="eager" fetchpriority="high" decoding="async">'
  : '';



  /* Richtext sáv a kártya tetején – induláskor elrejtve */
  var richTextBar = ''
    + '<div class="pc-rt" id="pc-rt">'
    +   '<button class="pc-rt-close" type="button" aria-label="Bezárás">×</button>'
    +   '<h4 id="pc-rt-title"></h4>'
    +   '<div class="rt-body" id="pc-rt-body"></div>'
    + '</div>';

  /* Ellenőrzött + pipa (Meta-szerű) a név alatt */
  /* Ellenőrzött + kapsz logót (13px) a név alatt, szürke szöveggel */
  var verified = ''
    + '<div class="pc-verified" aria-label="Ellenőrzött partner"'
    +     ' style="margin-top:6px;display:inline-flex;align-items:center;gap:6px;'
    +            'font-size:13px;color:#6b7280;">'
    +   '<span>Ellenőrzött</span>'
    +   '<img src="https://cdn.shopify.com/s/files/1/0679/3333/9954/files/letoltes_2.png?v=1761915524"'
    +        ' alt="" width="13" height="13"'
    +        ' style="display:inline-block;width:13px;height:13px;border-radius:999px;">'
    + '</div>';
;
var emailBadge = '';
if (p.email) {
  emailBadge =
    '<div class="pc-email">' +
      '<img class="pc-email-ico" src="https://cdn.shopify.com/s/files/1/0679/3333/9954/files/gmaillogo.png?v=1762040165" alt="" width="15" height="15">' +
      '<a href="mailto:'+escapeHtml(p.email)+'" class="pc-email-link">'+escapeHtml(p.email)+'</a>' +
    '</div>';
}
 var hasIcon = !!p.info_icon_url;

var infoBox = (p.info_title || p.info_text || hasIcon)
  ? ('<div class="pc-mini' + (hasIcon ? '' : ' pc-mini--noicon') + '">'
      + (hasIcon ? '<img class="pc-mini-ico" src="'+escapeHtml(p.info_icon_url)+'" alt="">' : '')
      + '<div class="pc-mini-text">'
        + (p.info_title ? '<h3>'+escapeHtml(p.info_title)+'</h3>' : '')
        + (p.info_text ? '<p>'+escapeHtml(p.info_text)+'</p>' : '')
      + '</div>'
    + '</div>')
  : '';


  var callBtn = p.phone ? '<a class="pc-btn pc-btn-primary" href="tel:'+encodeURIComponent(p.phone)+'">Hívás</a>' : '';
  var viewBtn = p.google_maps_url
    ? '<a class="pc-btn" href="'+escapeHtml(p.google_maps_url)+'" target="_blank" rel="noopener"><img src="https://www.gstatic.com/images/branding/product/2x/maps_96in128dp.png" alt="Google" width="18" height="18"> Megtekintés itt</a>'
    : '';

  return ''
    + '<div class="pc-card">'
      + richTextBar
      + '<div class="pc-head" style="text-align:center;">'
        + avatar
+ '<h3 class="pc-name">'
+   '<span class="pc-name-text">'+escapeHtml(p.name)+'</span>'
+   '<img class="pc-meta-badge" src="https://cdn.shopify.com/s/files/1/0679/3333/9954/files/letoltes_2.png?v=1761915524" alt="" width="16" height="16" loading="eager" decoding="async">'
+ '</h3>'
        + emailBadge
        + (fullAddr ? '<div class="pc-info" style="text-align:center;"><div class="pc-addr">'+escapeHtml(fullAddr)+'</div></div>' : '')
      + '</div>'
      + skillsHtml
      + infoBox
      + '<div class="pc-cta">'
        + callBtn
        + viewBtn
      + '</div>'
    + '</div>';
}

function showPopup(p, coords){
  var html = renderCard(p);

  if (state.popup){
    try { state.popup.remove(); } catch(_){}
    state.popup = null;
  }

  // --- Desktopon a marker JOBB OLDALÁRA tesszük (anchor: 'left'),
  // de ha nem fér ki, automatikusan átváltunk bal oldalra (anchor: 'right').
  // Mobilon mindegy, mert CSS középre teszi (fixed overlay).
  var isDesktop = window.innerWidth >= 992;
  var anchor = 'auto';
  var offset = 16;

  if (isDesktop){
    var pt = state.map.project(coords);
    var cont = state.map.getContainer();
    var contW = cont.clientWidth || cont.offsetWidth || window.innerWidth;
    var padding = 24;
    var cardW = 380;                    // <- legyen összhangban a CSS-sel

    var fitsRight = (pt.x + cardW + padding) <= contW;
    anchor = fitsRight ? 'left' : 'right';       // 'left' => kártya a pont JOBB oldalán
    // vízszintes finom offset (jobbra/balra 12px)
    offset = fitsRight ? [12, 0] : [-12, 0];
  }

  state.popup = new maplibregl.Popup({
    closeButton: true,
    closeOnClick: true,
    anchor: anchor,
    offset: offset,
    maxWidth: 'none'                     // a kártya mérete dönt
  })
  .setLngLat(coords)
  .setHTML(html)
  .addTo(state.map);
  wirePopupInteractions(p);
try {
  document.body.classList.add('has-popup');
  if (state.popup && typeof state.popup.on === 'function') {
    state.popup.on('close', function(){ 
      try { document.body.classList.remove('has-popup'); } catch(_){}
    });
  }
} catch(_){}

// Mobilon: takarítsuk el az inputot és a találatlistát, hogy biztosan ne maradjon nyitva
try {
  if (window.innerWidth < 992) {
    var input = document.getElementById('partnerSearch');
    var results = document.getElementById('searchResults');
    if (results){ results.innerHTML=''; results.classList.remove('open'); }
    if (input){
      input.value = '';
      input.blur();
      input.dispatchEvent(new Event('input', { bubbles:true }));
    }
  }
} catch(_){}
try {
  var pop = document.querySelector('.maplibregl-popup');
  if (pop && pop.parentElement !== document.body) {
    document.body.appendChild(pop);
  }
} catch(_) {}
try {
  var img = document.querySelector('.maplibregl-popup .pc-avatar');
  if (img) {
    // villámgyors "reflow" és decode → a böngésző teljes felbontásban rendereljen
    var _n = img.naturalWidth; // hint cache-hez
    img.style.transform = 'translateZ(0)'; // kompozit réteg
    if (img.decode) { img.decode().catch(function(){}); }
  }
} catch(_) {}
try{
  var res = document.getElementById('searchResults');
  if (res){ res.innerHTML = ''; res.classList.remove('open'); }
}catch(_){}

  // --- TRACK: partner kártya megnyitás ---
  pmTrack('partner_profile_open', p, {
    source: 'map',
    device: window.innerWidth < 992 ? 'mobile' : 'desktop'
  });

}



  function resolveStyleUrl(){
    var key = cfg.maptilerKey;
    if (cfg.mapStyle === 'custom' && cfg.customStyleUrl) return cfg.customStyleUrl;
    var styleId = cfg.mapStyle || 'streets-v2'; // streets-v2, basic-v2, outdoor-v2, dataviz, hybrid, satellite
    return key
      ? ('https://api.maptiler.com/maps/'+styleId+'/style.json?key='+key)
      : 'https://demotiles.maplibre.org/style.json';
  }

  function initMap(){
    var styleUrl = resolveStyleUrl();

    state.map = new maplibregl.Map({
      container:'map',
      style: styleUrl,
      attributionControl:true,
      maxZoom: cfg.maxZoom||16
    });
    try{ state.map.addControl(new maplibregl.NavigationControl(),'top-right'); }catch(_){}
    try{ state.map.addControl(new maplibregl.FullscreenControl(),'top-right'); }catch(_){}

    var b = parseBounds(cfg.initialBounds||'');
    try{ state.map.fitBounds(b,{padding:50,duration:0}); }catch(_){}

    state.map.on('load', function(){
      state.map.addSource(state.markersSourceId, {
  type:'geojson',
  data: featuresFrom(state.data),
  cluster: false
});
// NINCS cluster layer, NINCS cluster count layer, NINCS cluster click handler


      state.map.addLayer({
        id: state.clustersLayerId, type:'circle', source: state.markersSourceId, filter:['has','point_count'],
        paint:{
          'circle-color': ['step',['get','point_count'],'#6ea8fe',10,'#3d8bfd',50,'#1f6feb'],
          'circle-radius': ['step',['get','point_count'],16,10,20,50,26],
          'circle-stroke-width':3,'circle-stroke-color':'#e6f0ff'
        }
      });
      state.map.addLayer({
        id: state.clusterCountLayerId, type:'symbol', source: state.markersSourceId, filter:['has','point_count'],
        layout:{ 'text-field':['get','point_count_abbreviated'],'text-size':12 },
        paint:{ 'text-color':'#ffffff' }
      });
      state.map.addLayer({
        id: state.unclusteredLayerId, type:'circle', source: state.markersSourceId, filter:['!',['has','point_count']],
        paint:{ 'circle-color':'#0d6efd','circle-radius':7,'circle-stroke-width':2,'circle-stroke-color':'#ffffff' }
      });

      state.map.on('click', state.clustersLayerId, function(e){
        var features = state.map.queryRenderedFeatures(e.point,{layers:[state.clustersLayerId]});
        var f = features[0]; if(!f) return;
        var clusterId = f.properties && f.properties.cluster_id;
        state.map.getSource(state.markersSourceId).getClusterExpansionZoom(clusterId, function(err, zoom){
          if(err) return;
          state.map.easeTo({ center: f.geometry.coordinates, zoom: zoom });
        });
      });

      state.map.on('click', state.unclusteredLayerId, function(e){
        var f = e.features && e.features[0]; if(!f) return;
        var props = {}; try{ props = JSON.parse(f.properties.json); }catch(_){}
        showPopup(props, f.geometry.coordinates);
      });

      state.map.on('mouseenter', state.clustersLayerId, function(){ state.map.getCanvas().style.cursor='pointer'; });
      state.map.on('mouseleave', state.clustersLayerId, function(){ state.map.getCanvas().style.cursor=''; });
      state.map.on('mouseenter', state.unclusteredLayerId, function(){ state.map.getCanvas().style.cursor='pointer'; });
      state.map.on('mouseleave', state.unclusteredLayerId, function(){ state.map.getCanvas().style.cursor=''; });
    });
  }

 function loadPartnersJSON(done){
  // Ha a Liquid már odaadta a CDN-es asset_url-t, azt használjuk:
  var url = cfg.partnersJsonUrl || '';
  if (!url) {
    // nagyon régi fallback – de Shopify preview alatt általában 404 lesz:
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    url = root + 'assets/' + (cfg.partnersJson || 'partners.json');
  }
  fetch(url, { credentials: 'same-origin' })
    .then(function(r){
      if(!r.ok) throw new Error('partners.json HTTP '+r.status);
      return r.json();
    })
    .then(function(arr){
  var raw = arr;
  if (!Array.isArray(raw)) {
    raw = (raw && (raw.partners || raw.items)) || (raw ? [raw] : []);
  }
  state.data = raw.map(normalizeRecord).filter(Boolean);
  if (!state.data.length) {
    console.warn('partners.json betöltve, de 0 érvényes rekord.');
  } else {
    console.log('Partner pontok:', state.data.length);
  }
  done();
})

    .catch(function(err){
      console.error('partners.json betöltési hiba:', err);
      state.data = [];
      done();
    });
}


  function initSearch(){
  var input = $('#partnerSearch');
var clear = $('#clearSearch');
var results = $('#searchResults');

if (!results.classList.contains('horizontal')) {
  results.classList.add('horizontal');
}
results.style.pointerEvents = 'auto';

if (!input || !results) return;

// ha nincs clear, kreáljunk egy rejtett pótlékot
if (!clear) {
  clear = document.createElement('button');
  clear.id = 'clearSearch';
  clear.type = 'button';
  clear.hidden = true;
  (input.parentElement || document.body).appendChild(clear);
}


    var last = '';
    input.addEventListener('input', function(){
      var q = input.value.trim();

      if(q===last) return; last = q;
      if(!q){ results.innerHTML=''; results.classList.remove('open'); return; }
      var matches = searchLocal(q, state.data).slice(0,20);
      var html = '';
      for(var i=0;i<matches.length;i++){
        var m = matches[i];
        html += '<div role="option" data-idx="'+m.__idx+'"><strong>'+escapeHtml(m.name)+'</strong>'+ (m.city?(' · '+escapeHtml(m.city)):'') +'<div class="sub">'+escapeHtml(m.address||'')+'</div></div>';
      }
      results.innerHTML = html;
      results.classList.toggle('open', matches.length>0);
    });

  results.addEventListener('click', function(e){
  var item = e.target.closest('[data-idx]'); if(!item) return;
  var idx = parseInt(item.getAttribute('data-idx'),10);
  var p = state.data[idx]; if(!p) return;

  // Mobilon: input ürítés + lista zárás + blur (lock NINCS!)
  if (isMobile()){
    try {
      var inputEl = document.getElementById('partnerSearch');
      if (inputEl){
        inputEl.value = '';
        inputEl.blur();
        inputEl.dispatchEvent(new Event('input', { bubbles:true }));
      }
      results.innerHTML = '';
      results.classList.remove('open');
    } catch(_){}
  } else {
    // Desktop: csak a lista zárása (input marad)
    results.innerHTML = '';
    results.classList.remove('open');
  }

  // Térkép mozgatás + popup
  state.map.easeTo({ center:[p.lng, p.lat], zoom: 12 });
  showPopup(p, [p.lng, p.lat]);
});




    clear.addEventListener('click', function(){
      input.value=''; last=''; results.innerHTML=''; results.classList.remove('open');
    });

    var geoBtn = document.getElementById('geoSearch');
    if (geoBtn && cfg.enableGeocoder && cfg.maptilerKey){
      geoBtn.addEventListener('click', function(){
        var q = prompt('Írj be egy címet vagy települést:');
        if(!q) return;
        var url = 'https://api.maptiler.com/geocoding/'+encodeURIComponent(q)+'.json?key='+cfg.maptilerKey+'&language=hu';
        fetch(url).then(function(r){ return r.json(); }).then(function(j){
          var feat = j && j.features && j.features[0];
          if(!feat) return alert('Nincs találat.');
          var lng = feat.center[0], lat = feat.center[1];
          state.map.easeTo({ center:[lng,lat], zoom: 11 });
        }).catch(function(){ alert('Geokódolási hiba.'); });
      });
    }
  }

  function searchLocal(q, data){
    q = q.toLowerCase();
    var res = [];
    for(var i=0;i<data.length;i++){
      var p = data[i];
      var hay = [p.name, p.city, p.address, (p.services||[]).join(' ')].join(' ').toLowerCase();
      if(hay.indexOf(q) !== -1){
        var o = {}; for(var k in p){ o[k]=p[k]; } o.__idx=i; res.push(o);
      }
    }
    return res;
  }

  function boot(){
    if (typeof maplibregl === 'undefined'){ console.error('MapLibre GL not loaded'); return; }
    loadPartnersJSON(function(){
      initMap();
      initSearch();
    });
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
function wirePopupInteractions(p){
  var root = document.querySelector('.maplibregl-popup .pc-card');
  if (!root) return;

  var rt     = root.querySelector('#pc-rt');
  var rtT    = root.querySelector('#pc-rt-title');
  var rtBody = root.querySelector('#pc-rt-body');
  var rtX    = root.querySelector('.pc-rt-close');

  function openRT(title, html){
    if (!rt) return;
    if (rtT) rtT.textContent = title || '';
    if (rtBody) rtBody.innerHTML = html || '';
    rt.classList.add('open');
  }
  function closeRT(){
    if (!rt) return;
    rt.classList.remove('open');
  }
var xBtn = document.querySelector('.maplibregl-popup-close-button');
  if (xBtn){
    xBtn.addEventListener('click', function(){
    }, { once:true });
  }
    // --- Gombkattintások trackelése ---
  // Telefon (Hívás gomb)
  root.querySelectorAll('a[href^="tel:"]').forEach(function(el){
    el.addEventListener('click', function(){
      pmTrack('partner_call_click', p, {
        source: 'map_popup',
        device: window.innerWidth < 992 ? 'mobile' : 'desktop'
      });
    });
  });

  // Email (mailto link az email badge-ben)
  root.querySelectorAll('a[href^="mailto:"]').forEach(function(el){
    el.addEventListener('click', function(){
      pmTrack('partner_email_click', p, {
        source: 'map_popup',
        device: window.innerWidth < 992 ? 'mobile' : 'desktop'
      });
    });
  });

  // Google Maps „Megtekintés itt” gomb (target="_blank")
  root.querySelectorAll('.pc-btn[href^="http"], a[target="_blank"]').forEach(function(el){
    el.addEventListener('click', function(){
      pmTrack('partner_maps_click', p, {
        source: 'map_popup',
        device: window.innerWidth < 992 ? 'mobile' : 'desktop'
      });
    });
  });

  // ikonok -> leírás
  var desc = {
    car: '<p>Az <strong>Autók</strong> ikon azt jelzi, hogy a partner vállal gépjármű bőrápolást, színfrissítést és javítást (kormány, ülés, kárpit).</p>',
    furniture: '<p>A <strong>Bútorok</strong> ikon a lakásban/irodában található bőrfelületek (kanapé, fotel, szék) tisztítását, javítását és színhelyreállítását jelenti.</p>'
  };
  // ha van partner-szintű info_text, tegyük a végére
  var tail = p && p.info_text ? '<p style="margin-top:8px; color:#475569;">'+escapeHtml(p.info_text)+'</p>' : '';

  root.querySelectorAll('.pc-skill[data-kind]').forEach(function(el){
    el.addEventListener('click', function(){
      var kind = el.getAttribute('data-kind');
      var title = el.getAttribute('data-title') || 'Információ';
      var body = (desc[kind] || '<p>Szolgáltatás részletei.</p>') + tail;
      openRT(title, body);
    });
  });

  if (rtX) rtX.addEventListener('click', closeRT);
}
